module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAAdElEQVQokb2SwQ2AIBAE54xNUBJ1aFvWYUUCXeBDICokghIn2RfsAcvKSoYGFkDlSxcsMElhgKkwpyEj4Cs3l1DDBzMA5wESZBv8rnSDGXAV5o0QYsxAGk5OdM0gojm+0j/IALr0hOYeRN70oU8P5KZ/e7ADkHcgYFOsXQoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add01.png
// module id = 6iSs
// module chunks = 1